import {filterPermission, info, login, logout, register} from '@//api/user'
import {getToken, removeToken, setToken} from '@/utils/auth'
import {resetRouter} from '@/router'
import {clearAdminEnter} from '@/utils/admin-enter'
import Fingerprint2 from 'fingerprintjs2'


const getFingerprint = function () {
  return new Promise((resolve) => {
    Fingerprint2.get((result) => {
      const values = result.map(component => component.value);
      const hash = Fingerprint2.x64hash128(values.join(''), 31);
      resolve(hash)
    })
  })
}
const state = {
  token: getToken(),
  name: 'manager',
  info: {balance: 0},
  avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
  introduction: '',
  roles: [],
  permissions: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_INFO: (state, info) => {
    state.info = info
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
}

const actions = {
  // user login
  login({commit}, userInfo) {
    const {email, password} = userInfo
    return new Promise((resolve, reject) => {
      login({email: email.trim(), password: password}).then(response => {
        const {data} = response
        commit('SET_TOKEN', data.token)
        commit('SET_INFO', data)
        commit('SET_NAME', data.username)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user register
  register({commit}, data) {
    return new Promise(async (resolve, reject) => {
      data.deviceFingerprint = await getFingerprint();
      register(data).then(response => {
        const {data} = response
        commit('SET_TOKEN', data.token)
        commit('SET_INFO', data)
        commit('SET_NAME', data.username)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  logout({commit, state, dispatch}) {
    return new Promise(resolve => {
      logout(state.token).catch(() => {}).finally(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        clearAdminEnter()
        resetRouter()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, {root: true})

        resolve()
      })
    })
  },
  // get user info
  info({commit, state}) {
    return new Promise(async (resolve, reject) => {
      const fingerprint = await getFingerprint();
      const data = {
        deviceFingerprint: fingerprint,
      }
      info(data)
        .then(res => {
          const {data} = res
          commit('SET_INFO', data)
          commit('SET_NAME', data.username)
          resolve(data)
        }).catch(error => {
        reject(error)
      })
    })
  },
  // get permissions info
  filterPermission({commit, state}) {
    return new Promise((resolve, reject) => {
      filterPermission().then(res => {
        const {data} = res
        commit('SET_PERMISSIONS', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  setRoles({commit}, roles) {
    commit("SET_ROLES", roles)
  },
  // remove token
  resetToken({commit}) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      clearAdminEnter()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
